import React from 'react';
import { SignUpForm, HandleSignUpProps } from 'app/components/auth/SignUp/SignUpForm';
import { styled } from '@goodrx/matisse';
import { SignInCta } from 'app/components/auth/SignUp/SignInCta';
import * as Analytics from 'app/lib/analytics';
import { sessionStorage } from 'app/lib/storage';
import * as Sentry from '@sentry/browser';
import { useSynapse } from 'app/lib/synaptik';
import { useRouter } from 'next/router';

// Unfortunately need to use !importants and nested selectors here to override
// theme styles coming in from using x-content blocks
// will remove them once the theming issue is resolved and
// it is no longer code locked - David Torbeck
const Title = styled.h2`
  font-size: ${(p) => p.theme.space[4]}px !important;
`;

const StyledSignInCta = styled(SignInCta)`
  display: flex;
  justify-content: center;
  > span {
    font-size: 14px;

    a {
      font-size: 14px;
      text-decoration: underline;
    }
  }
`;

const Wrapper = styled.div`
  background-color: white;
  border-radius: ${(p) => p.theme.space[3]}px;
  padding: 20px 20px ${(p) => p.theme.space[4]}px;
  width: 384px;
  box-shadow: 0px 4px 11px #a7c4de;

  label {
    margin-bottom: 0 !important;
    > span {
      margin-left: 10px;
    }
  }

  button {
    margin-top: ${(p) => p.theme.space[5]}px;

    &:last-child {
      margin-bottom: 10px !important;
    }
  }

  .re-checkbox-shape {
    margin-top: 4px;
  }

  .re-label {
    font-size: ${(p) => p.theme.space[3]}px;
  }

  .re-box-component {
    .re-form-error {
      margin: 0 !important;
    }
  }

  li > p {
    font-size: 14px;
  }

  ul > li:nth-child(1) {
    margin-bottom: ${(p) => p.theme.space[2]}px;
  }

  .re-box > div > div > p {
    margin-top: ${(p) => p.theme.space[2]}px;
    margin-left: 28px;
    font-size: 14px;

    span {
      font-size: 14px;
    }
  }

  a {
    font-weight: 500;
  }
`;

export const SignUpOnHomePage: React.FC = () => {
  const [signUp, signingUp] = useSynapse(({ user }) => [user.signUp, user.state.signingUp]);
  const router = useRouter();

  async function handleSignUp({ values, isValid }: HandleSignUpProps) {
    const { email, password, consentedToHma } = values;

    if (!isValid || !email || !password) return;

    try {
      // Clear onboarding values if they exist before register on home page to prevent mismatched emails
      sessionStorage.remove('onboarding');

      await signUp({ email, password, consentedToHma: !!consentedToHma });

      if (consentedToHma) {
        Analytics.onHmaConsent({ source: 'Sign Up' });
      }

      Analytics.trackEvent('Registration CTA Clicked', {
        buttonName: 'Start Your Visit',
        page: 'Eligibility, Email Password, Profile, homepage',
      });

      router.push('/account/start');
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  return (
    <Wrapper>
      <Title>Sign Up</Title>
      <SignUpForm onSubmit={handleSignUp} isLoading={signingUp} useNextLinks ctaCopy="Start Your Visit" />
      <StyledSignInCta useNextLink hideChevron />
    </Wrapper>
  );
};
